import { animate, type AnimationScope, transform } from 'framer-motion';

type BaseAnimation = (
  currentScrollValue: number,
  maxScrollValue: number,
) => void;

interface LotteryRewardsAnimationsRef {
  animateTitle: BaseAnimation;
  animateValue: BaseAnimation;
  animateTop: BaseAnimation;
  animateAll: BaseAnimation;
}

interface ConstructorArgs {
  titleRef: AnimationScope<HTMLDivElement>;
  valueRef: AnimationScope<HTMLDivElement>;
  topRef: AnimationScope<HTMLDivElement>;
}

class LotteryRewardsAnimation implements LotteryRewardsAnimationsRef {
  private titleRef: AnimationScope<HTMLDivElement>;
  private valueRef: AnimationScope<HTMLDivElement>;
  private topRef: AnimationScope<HTMLDivElement>;

  constructor({ titleRef, valueRef, topRef }: ConstructorArgs) {
    this.titleRef = titleRef;
    this.valueRef = valueRef;
    this.topRef = topRef;
  }

  animateTitle(currentScrollValue: number, maxScrollValue: number): void {
    const title = this.titleRef.current;

    if (!title) return;

    const toOpacity = transform([0, maxScrollValue], [1, 0]);

    animate(
      title,
      {
        opacity: toOpacity(currentScrollValue),
      },
      { ease: 'linear' },
    );
  }

  animateTop(currentScrollValue: number, maxScrollValue: number): void {
    const top = this.topRef.current;

    if (!top) return;
    // const toHeight = transform([0, maxScrollValue], ['64px', '40px']);
    const toY = transform([0, maxScrollValue], ['0px', '56px']);

    animate(
      top,
      {
        y: toY(currentScrollValue),
      },
      { ease: 'linear' },
    );
  }

  animateValue(currentScrollValue: number, maxScrollValue: number): void {
    const value = this.valueRef.current;

    if (!value) return;

    const toFontSize = transform([0, maxScrollValue], ['64px', '40px']);

    animate(
      value,
      {
        fontSize: toFontSize(currentScrollValue),
      },
      { ease: 'linear' },
    );
  }

  animateAll(currentScrollValue: number, maxScrollValue: number): void {
    this.animateValue(currentScrollValue, maxScrollValue);
    this.animateTitle(currentScrollValue, maxScrollValue);
    this.animateTop(currentScrollValue, maxScrollValue);
  }
}

export { LotteryRewardsAnimation, type LotteryRewardsAnimationsRef };
